import _ from '../../core/utils'
import NEWS_CONFIG from './config'
import API from '../api'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'

class NewsClass {
    constructor() {
        this.DOM = {
            section: NEWS_CONFIG.section,
            grid: {
                wrap: NEWS_CONFIG.grid.wrap,
                items: NEWS_CONFIG.grid.items,
                noresults: NEWS_CONFIG.grid.noresults
            },
            search: {
                form: NEWS_CONFIG.search.form,
                input: NEWS_CONFIG.search.input,
                clear: NEWS_CONFIG.search.clear,
                loader: NEWS_CONFIG.search.loader,
                submit: NEWS_CONFIG.search.submit,
            }
        }

        this.endpoint = NEWS_CONFIG.endpoint
        this.isotope = null
        this.DOM.section ? this.init() : null
    }

    init() {
        this._listeners()
        this._isotope()
        console.log( this )
    }

    _listeners() {
        this.DOM.search.form.addEventListener( 'submit', this._search.bind( this ) )
        this.DOM.search.clear.addEventListener( 'click', this._clear.bind( this ) )
    }

    _isotope() {
        this.isotope = new Isotope ( this.DOM.grid.wrap, {
        })

        imagesLoaded( this.DOM.grid.wrap ).on( 'progress', () => {
            this.isotope.arrange({
                filter: '.fl__card--new'
            })
        })
    }

    _search() {
        event.preventDefault()

        _.addClass( this.DOM.section, 'is--searching' )

        API.post( this.endpoint, 
            new FormData( this.DOM.search.form )
        )
        .then( ( response ) => {
            if ( response.data.success ) {
                this._results( response )
            }
        })
        .catch( ( error ) => {
            console.log( error )
        })
        .then( () => {
            _.removeClass( this.DOM.section, 'is--searching' )
            _.addClass( this.DOM.section, 'is--searched' )
        })
    }

    _results( response ) {

        this.DOM.grid.items.forEach( ( item ) => {
            _.removeClass( item, 'fl__card--filtered' )
        })

        if ( response.data.results.length > 0 ) {
           let results = response.data.results

            results.forEach( ( result ) => {
                let item = _.select( `.fl__card--new[data-id="${result}"]` )
                _.addClass( item, 'fl__card--filtered' )
            })

            this.isotope.arrange({
                filter: '.fl__card--filtered'
            })


        } else {
            _.addClass( this.DOM.section, 'is--noresults' )

            this.isotope.arrange({
                filter: '.fl__card--noresults'
            })
        }
    }

    _clear() {
        
        this.DOM.grid.items.forEach( ( item ) => {
            _.removeClass( item, 'fl__card--filtered' )
        })

        _.removeClass( this.DOM.section, 'is--noresults' )
        _.removeClass( this.DOM.section, 'is--searched' )
        this.DOM.search.input.value = ''
        this.isotope.arrange({
            filter: '.fl__card--new'
        })
    }
   
}

const NEWS = new NewsClass()
export default NEWS